import { getImageUrl, useGetImage, useGetProjects } from '@provider';
import { navigate } from 'gatsby';
import React from 'react'
import { nextPageContainer } from '../styles';
import { useLocation } from '@reach/router';

const TemplateNextContent = () => {
    const {getImage} = useGetImage();
    const {projects} = useGetProjects();
    const location = useLocation();
    const [nextProject, setNextProject] = React.useState<any>(null);

    React.useEffect(() => {
        if (!projects || projects.length === 0) return;
        const current = projects.find(p => location.pathname.includes(p.slug));
        if (!current) return;
        const idx = projects.findIndex(p => p.id === current.id);
        if (idx === -1 || idx === projects.length - 1) {
            setNextProject(null);
            return;
        }
        const next = projects[idx + 1];
        const endContent = {
            header: next.title,
            image: next.image,
            description: next.description,
            id: next.id,
            title: next.title,
        };
        if (!nextProject) {
            setNextProject(endContent)
        }
    }, [projects, location.pathname, getImage, nextProject]);


    if (!nextProject) return null;

    return (
        <div css={nextPageContainer}>
            <img
                src={getImageUrl({filePath: getImage(nextProject.image)})}
                alt={nextProject.title}
                style={{width: 'auto', height: '100%', objectFit: 'cover', position: 'absolute', top: 0, left: 0, zIndex: -1}}
            />
        </div>
    )
}

export default TemplateNextContent;